import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, MTabsInpage, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LaneConfig from './laneConfig';
import LaneConfigCrud from './laneConfigCrud';

export default function LanePage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const location = useLocation();
    const { renameTab } = useContext(NavigateContext);
    const selectedTab = M_State.find(obj => obj.key === 'selectedTab')?.value || 'lane';

    const [menu, setMenu] = useState(1);
    const [selectedLane, setSelectedLane] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const [id, setId] = useState(() => M_State.find(obj => obj.key === 'selectedTab')?.value || 'lane');

    const sessionKeys = ['menu', 'selectedLane', 'refresh']; // Keys to store in session storage

    //============================================================================================================
    // EFFECT
    // Rename the tab when the selectedTab changes
    //============================================================================================================
    useEffect(() => { 
        if (!selectedTab) return; // Guard clause to ensure selectedTab is defined
        renameTab(String(selectedTab), t('Lanes')); // Rename the tab using the translation for 'Lanes'
    }, [selectedTab, t]);

    //============================================================================================================
    // Function to get session storage data based on session ID
    //============================================================================================================
    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const session = M_State.find(obj => obj.key === sessionID)?.value; // Retrieve the session data from M_State
        if (session) {
            const m = session.find(x => x.key === 'menu')?.value; // Get the menu value from session
            const lane = session.find(x => x.key === 'selectedLane')?.value; // Get the selected lane from session
            const ref = session.find(x => x.key === 'refresh')?.value; // Get the refresh value from session
            if (m) setMenu(m); // Set the menu state
            if (lane) setSelectedLane(lane); // Set the selected lane state
            if (ref !== undefined) setRefresh(ref); // Set the refresh state
        }
        ctx.setIsLoad(false);
    };

    //============================================================================================================
    // EFFECT
    // Load session data when the component mounts
    //============================================================================================================
    useEffect(() => {
        getSessionStorageData(id); // Load session data when the component mounts
        setRefresh(r => !r); // Toggle refresh state to trigger re-render
    }, [location.pathname]);

    //============================================================================================================
    // EFFECT
    // Persist the current state to session storage
    //============================================================================================================
    useEffect(() => {
        const values = { menu, selectedLane, refresh }; // Current state values to store
        const sessionData = sessionKeys.map(k => ({ key: k, value: values[k] })); // Create an array of key-value pairs for session storage
        dispatch(M_StateActions.addM_State({ key: id, value: sessionData })); // Dispatch action to add/update session data in M_State
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, menu, selectedLane, refresh]);

    return (
        <div className="divGlobalSettings">
            <div style={matches ? { display: 'flex' } : {}}>
                <div className="settingsPageMainDiv">
                    <Routes>
                        <Route index element={
                            <LaneConfig // Main lane configuration component with the dunamic table
                                roles={roles}
                                onCreateTab={onCreateTab}
                                toastMessages={toastMessages}
                                selectedLane={selectedLane}
                                setSelectedLane={setSelectedLane}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        } />
                        <Route path='laneConfigCrud' element={
                            <LaneConfigCrud // Lane configuration CRUD component
                                handleTabClose={handleTabClose}
                                toastMessages={toastMessages}
                            />
                        } />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
